import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { HolidaysTable } from '.';
import DatePicker from 'antd/lib/date-picker';
import moment from 'moment'

const { RangePicker } = DatePicker;

@translate()
export default class HolidaysList extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    holidays: PropTypes.array.isRequired,
    pagination: PropTypes.object.isRequired,
    filter: PropTypes.object.isRequired,
    onTableChange: PropTypes.func.isRequired,
    onFilterSearchChange: PropTypes.func.isRequired,
    onFilterDateRangeChange: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
  };
  constructor(props) {
    super(props);

    //oldest email logs are in July 2021
    const defaultFromDate = moment.utc("2021-07-01").format("YYYY-MM-DD") + "T00:00:00.000Z";
    this.state = {
      sentDateRange: {
        from: defaultFromDate,
        to: moment.utc().endOf('day').toISOString()
      }
    }
  }

  render() {
    const {
      holidays,
      pagination,
      filter,
      onTableChange,
      onFilterSearchChange,
      onFilterDateRangeChange,
      isLoading,
      t,
    } = this.props;
    return (

      <section>
        <h2>{t('Sviatky a voľné dni')}</h2>

        {/* 
        <Row center="xs" className="filters padded">
          <Col xs={12} sm={4}>
            <Search
              key="holidaySearch"
              defaultValue={filter.search}
              onSearch={onFilterSearchChange}
            />
          </Col>
                 <Col xs={12} sm={4}>
            <RangePicker
              onChange={onFilterDateRangeChange}
              format="DD.MM.YYYY"
              style={Object.assign({ marginRight: 15 })}
              defaultValue={[moment.utc(this.state.sentDateRange.from), moment.utc(this.state.sentDateRange.to)]}
            />
          </Col>
        </Row> */}

        <HolidaysTable
          holidays={holidays}
          pagination={pagination}
          onChange={onTableChange}
          loading={isLoading}
          t={t}
        />
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/messaging-dashboard/components/HolidaysList.js